import api from "../api/Client";

export type ProfessionalScheduleAvailability = {
  coach_availability_id: number;
  coach_id: number;
  days: string;
  day_label: string;
  activacion: string | null;
  desactivacion: string | null;
  morning_start_time: string | null;
  morning_end_time: string | null;
  afternoon_start_time: string | null;
  afternoon_end_time: string | null;
  service_id_morning: number | null;
  service_id_afternoon: number | null;
  capacity_morning: number | null;
  capacity_afternoon: number | null;
  center_id: number | null;
  center_name: string | null;
  service_name_morning: string | null;
  service_name_afternoon: string | null;
};

export type ProfessionalScheduleTemplateSlot = {
  rrhh_schedule_template_slot_id: number;
  rrhh_schedule_template_id: number;
  weekday: number;
  weekday_label: string;
  start_time: string;
  end_time: string;
  service_id: number | null;
  service_name: string | null;
  capacity: number | null;
  notes: string | null;
};

export type ProfessionalScheduleTemplate = {
  rrhh_schedule_template_id: number;
  user_id: number;
  center_id: number | null;
  center_name: string | null;
  title: string;
  valid_from: string | null;
  valid_to: string | null;
  status: string;
  created_at: string | null;
  updated_at: string | null;
  slots: ProfessionalScheduleTemplateSlot[];
};

export type ProfessionalUpcomingLeave = {
  leave_id: number;
  title: string;
  start_date: string;
  end_date: string;
  start_time: string | null;
  end_time: string | null;
  not_available_this_day: number;
  type_name: string | null;
};

export type ProfessionalCenterClosure = {
  holiday_id: number;
  holiday_name: string;
  date: string;
};

export type ProfessionalScheduleSummary = {
  availability_blocks: number;
  working_days: number;
  active_templates: number;
  upcoming_leaves: number;
  center_closures: number;
};

export type ProfessionalScheduleResponse = {
  summary: ProfessionalScheduleSummary;
  availability: ProfessionalScheduleAvailability[];
  schedules: ProfessionalScheduleTemplate[];
  upcoming_leaves: ProfessionalUpcomingLeave[];
  center_closures: ProfessionalCenterClosure[];
};

export async function fetchProfessionalSchedule() {
  const response = await api.get("/api/professionals/schedule");
  return response.data as ProfessionalScheduleResponse;
}
